import { MessageSquare, Sparkles } from "lucide-react";
import { useState } from "react";

import { ChatAgente } from "@/components/agenti/ChatAgente";
import { Button } from "@/components/ui/button";

const BASE_PATH = "/api/v1/presidenza/agente/chat";


const CHIPS = [
  "Riepilogo OMC",
  "Come va l'OTIF?",
  "Ordini critici di oggi",
  "Sollecita Marina sui carichi senza paese",
];

/**
 * Assistente di presidenza (M4): agente AI direzionale. Interroga KPI, OMC e
 * anomalie e può creare un sollecito in Bacheca. Riusa l'UI chat unica
 * (`ChatAgente`) puntata sul proprio agente (`agente_tipo=presidenza`).
 */
export function WidgetAssistentePresidenza() {
  const [chatOpen, setChatOpen] = useState(false);
  const [bozza, setBozza] = useState<string | undefined>(undefined);

  function apri(prompt?: string) {
    setBozza(prompt);
    setChatOpen(true);
  }

  return (
    <section className="flex h-full flex-col rounded-xl border bg-card/60 p-5">
      <header className="flex items-start gap-3">
        <div className="flex size-9 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-brand-500 to-brand-700 text-white">
          <Sparkles className="size-4" aria-hidden="true" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <h2 className="truncate text-sm font-semibold tracking-tight">
              Assistente di presidenza
            </h2>
            <span className="rounded bg-brand-700 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white">
              AI
            </span>
          </div>
          <p className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <span className="size-1.5 rounded-full bg-emerald-600" />
            attivo · interroga dati e inoltra solleciti
          </p>
        </div>
      </header>

      <p className="mt-3 text-xs text-muted-foreground">
        Chiedi un riepilogo di obiettivi, indicatori e anomalie — e fai inoltrare
        un sollecito a Marina o Fabio quando serve.
      </p>

      <div className="mt-3 flex flex-wrap gap-2">
        {CHIPS.map((c) => (
          <button
            key={c}
            type="button"
            onClick={() => apri(c)}
            className="rounded-full border px-2.5 py-1 text-xs text-muted-foreground transition-colors hover:border-brand-300 hover:bg-accent hover:text-brand-700"
          >
            {c}
          </button>
        ))}
      </div>

      <div className="mt-auto pt-4">
        <Button size="sm" onClick={() => apri()}>
          <MessageSquare className="size-4" /> Apri assistente
        </Button>
      </div>

      {/* Stesso componente di Aida e Iris. Qui in overlay e senza barra:
          l'apertura la comanda il pulsante del widget, e nella dashboard non
          c'è un bordo di pagina su cui appoggiare la barra. */}
      <ChatAgente
        aperta={chatOpen}
        onApertaChange={setChatOpen}
        nome="Presidenza"
        stato="assistente di presidenza"
        basePath={BASE_PATH}
        modo="overlay"
        mostraBarra={false}
        benvenuto="Posso leggere obiettivi, indicatori e anomalie, e creare un sollecito. Cosa ti serve?"
        suggerimenti={CHIPS}
        bozzaIniziale={bozza}
      />
    </section>
  );
}
